import React from "react";

import type { Impulse } from "~/tools/impulse";
import type { StreamRegistry } from "~/tools/stream-manager/registry";
import type { StreamStore } from "~/tools/stream-manager/store";
import { useRequiredContext } from "~/tools/use-required-context";

import type { manager } from "./manager";

export interface WebSocketContextValue {
	registry: Impulse<StreamRegistry<typeof manager>>;
	store: Impulse<StreamStore<typeof manager>>;
}

const WebSocketContext = React.createContext<null | WebSocketContextValue>(null);

export const WebSocketContextProvider = WebSocketContext.Provider;

export const useWebSocketContext = (): WebSocketContextValue =>
	useRequiredContext(WebSocketContext, {
		providerName: "WebSocketProvider",
	});
